import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayPaymentMqttEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/paymentmqtt/`
        this.webApi = new WebApi()
    }

    // get configuration ID by point ID
    async getConf (pointId) {
        const response = await this.webApi.get(`${this.url}GetConf/${pointId}`)
        return response.value
    }

    // get configuration ID by point ID for object pos
    async getConfPos (pointId) {
        const response = await this.webApi.get(`${this.url}GetConfPos/${pointId}`)
        return response.value
    }

    async getConfiguration (configurationId) {
        const response = await this.webApi.get(`${this.url}GetConfiguration/${configurationId}`)
        return response
    }

    async getEquipment (equipmentId) {
        const response = await this.webApi.get(`${this.url}GetEquipment/${equipmentId}`)
        return response
    }

    async getSbpState (sbpId) {
        return this.webApi.get(`${this.url}GetSbpState/${sbpId}`)
    }

    async getTimeout () {
        return this.webApi.get(`${this.url}GetTimeout`)
    }

    async sendMessage (request) {
        return this.webApi.post(`${this.url}SendMessage`, request)
    }
}
